var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 29,
  rx: 14.5,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 29,
  rx: 14.5,
  stroke: "black"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.0218 14.6103C6.0218 14.6103 13.3931 11.8663 15.9495 10.9001C16.9296 10.5136 20.253 9.27685 20.253 9.27685C20.253 9.27685 21.7869 8.73581 21.6591 10.0498C21.6165 10.5909 21.2756 12.4846 20.9348 14.533C20.4234 17.4316 19.8695 20.6007 19.8695 20.6007C19.8695 20.6007 19.7843 21.4897 19.06 21.6442C18.3357 21.7988 17.1426 21.1032 16.9296 20.9486C16.7591 20.8327 13.7339 19.0935 12.6261 18.2432C12.3278 18.0113 11.987 17.5476 12.6687 17.0065C14.2026 15.7311 16.0348 14.1465 17.1426 13.1417C17.6539 12.6779 18.1652 11.5958 16.0348 12.9098C13.0096 14.8035 10.027 16.5814 10.027 16.5814C10.027 16.5814 9.34524 16.9678 8.06701 16.62C6.78871 16.2722 5.29742 15.8084 5.29742 15.8084C5.29742 15.8084 4.27487 15.2287 6.0218 14.6103Z",
  fill: "black"
})));
export default SvgIconTelegram;